export default "__VITE_ASSET__CatLv7w9__"